<template>
  <div id="personCenter">
    <div class="main">
      <span v-show="islogin !== '1'" class="loginBtn nologin" @click="loginClick()">
        <i class="icon"></i>点击登录
      </span>
      <p class="username" v-show="islogin === '1'">手机用户{{user.tails.userinfo[0].account}}</p>
      <!-- TODO update by 2022-2-22 14:34 with zp -->
      <div class="msg-layout" @click="msgIconClick()" v-show="islogin === '1'">
        <img src="../images/ic_person_msg.png"/>
        <i v-if="mHasNewMsgData"></i>
      </div>
      <!-- TODO  -->
      <span v-show="islogin === '1'" class="loginBtn logined">
        <i class="icon"></i>{{user.ent_name}}
      </span>
      <div class="orderPart">
        <p class="firstLine">我的订单<span class="checkmore" @click="ToAll()">查看全部订单 ></span></p>
        <div class="iconPart">
          <div class="item" @click="To(index)" v-for="(item,index) in orderIconList" :key="index">
            <span class="total" v-show="item.total>0">{{item.total > 99 ? '99+':item.total}}</span>
            <img :src="item.img" alt="" class="itemIcon">
            <p class="itemText">{{item.name}}</p>
          </div>
        </div>
      </div>
      <!-- TODO update by 2022-2-22 14:34 with zp -->
      <div class="buyCenter">
        <p class="firstLine">采购中心</p>
        <div class="iconPart">
          <div class="item" @click="itemBuyClick(index)" v-for="(item,index) in mBuyList" :key="index">
            <img :src="item.img" alt="" class="itemIcon">
            <p class="itemText">{{item.name}}</p>
          </div>
        </div>
      </div>
      <!-- TODO  -->
      <div class="tools">
        <p class="firstLine">常用工具</p>
        <div class="iconPart">
          <div class="item" @click="ToTools(index)" v-for="(item,index) in tools" :key="index">
            <img :src="item.img" alt="" class="itemIcon">
            <p class="itemText">{{item.name}}</p>
          </div>
        </div>
      </div>
      <div class="logOut" v-show="islogin === '1'&&enterType===0" @click="showLogOut()">退出登录</div>
    </div>
    <div class="masker" v-if="showMask || showMaskLogOut"></div>
    <div class="servicePhone" v-if="showMask" :style="{paddingBottom: (tabHeight)+'px'}">
      <p class="phoneNumber" @click="callService">客服热线：400 1919 119</p>
      <p class="cancle" @click="hide()">取消</p>
    </div>
    <div class="logOutPop" v-if="showMaskLogOut" :style="{paddingBottom: tabHeight+'px'}">
      <p class="checkout" @click="switchAccount()">更换账户登录</p>
      <p class="out" @click="logout()">退出登录</p>
      <p class="cancle" @click="hide()">取消</p>
    </div>

    <bottomNav :viewName="'personHomePage'"></bottomNav>
    <loginPop :show="showLogin" @click="loginPopClick"></loginPop>
  </div>
</template>

<script>
import bottomNav from '../../../components/bottomNavigation'
import loginPop from '../goods/pop-login'
import Axios from 'axios'
import { mapState } from 'vuex'
import { Toast } from 'vant'
export default {
  computed: {
    ...mapState({
      reloadOrderId: 'MallOrderId'
    })
  },
  inject: ['reload'],
  components: {
    bottomNav,
    loginPop
  },
  data () {
    return {
      tabHeight: 0,
       mBottom: parseInt(this.$route.query.isTab) === 1 ? 50 : 0,
      showLogin: false,
      showMask: false,
      showMaskLogOut: false,
      enterType: 0,
      user: {
        tails: {
          userinfo: [
            {
              account: ''
            }
          ]
        }
      },
      islogin: '',
      orderIconList: [
        {
          img: require('../images/toPay.png'),
          name: '待付款',
          total: Number
        },
        {
          img: require('../images/toSend.png'),
          name: '待发货',
          total: Number
        },
        {
          img: require('../images/toCheck.png'),
          name: '待收货',
          total: Number
        },
        {
          img: require('../images/done.png'),
          name: '已完成',
          total: Number
        }
      ],
      routerList: [
        {
          path: 'OrderListCenter',
          name: '订单列表'
        },
        {
          path: 'BillCenter',
          name: '发票管理'
        },
        {
          path: 'AddressCenter',
          name: '地址管理'
        }
      ],
      mBuyList: [
        {
          img: require('../images/ic_price_list.png'),
          name: '报价列表'
        },
        // {
        //   img: require('../images/ic_add_buy.png'),
        //   name: '发布采购'
        // },
        // {
        //   img: require('../images/ic_buy_list.png'),
        //   name: '采购列表'
        // },
        { img: '', name: '' },{ img: '', name: '' },{ img: '', name: '' }
      ],
      tools: [
        {
          img: require('../images/addressManagement.png'),
          name: '地址管理'
        },
        {
          img: require('../images/billManagement.png'),
          name: '发票管理'
        },
        {
          img: require('../images/service.png'),
          name: '客服热线'
        },
        {
          img: '',
          name: ''
        }
      ],
      mHasNewMsgData: false, // 是否有最新的消息数据
      mMsgTimer: null // 定时器
    }
  },
  methods: {
    msgIconClick () {
      this.$router.push({
        path: '/informList',
      })
    },
    itemBuyClick (position) {
      if (position !== 3) {
        if (localStorage.getItem('isLogin') === '1') {
          switch (position) {
            case 0: // 采购列表
              this.$router.push({
                path: '/offerList',
              })
              break;
          }
        } else {
          this.showLogin = true
        }
      }
    },
    To (index) {
      if (localStorage.getItem('isLogin') === '1') {
        this.$store.commit('clearOrderId', '')
        this.$router.push({
          path: '/orderListCenter',
          query: {
            status: index,
            tag: index + 1
          }
        })
      } else {
        this.showLogin = true
      }
    },
    ToAll () {
      if (localStorage.getItem('isLogin') === '1') {
        this.$store.commit('clearOrderId', '')
        this.$router.push({
          path: '/orderListCenter',
          query: {
            status: 4,
            tag: 0
          }
        })
      } else {
        this.showLogin = true
      }
    },
    ToTools (i) {
      switch (i) {
        case 0:
          if (localStorage.getItem('isLogin') === '1') {
            this.$router.push({
              path: '/addressCenter'
            })
          } else {
            this.showLogin = true
          }
          break
        case 1:
          if (localStorage.getItem('isLogin') === '1') {
            this.$router.push({
              path: '/billCenter'
            })
          } else {
            this.showLogin = true
          }
          break
        case 2:
          this.showMask = true
          break
        default:
          break
      }
    },
    loginClick () {
      this.showLogin = true
    },
    loginPopClick: function (type) {
      this.showLogin = false
      if (type === 1) {
        this.isLogin = 1
      }
      if (type === 2) {
        this.$router.push({ path: '/register' })
      }
      if (type === 3) {
        this.$router.push({ path: '/retrieve' })
      }
      this.reload()
    },
    showLogOut () {
      this.showMaskLogOut = true
    },
    switchAccount () {
      this.showMaskLogOut = false
      this.$router.push({
        path: '/homePage/login',
        query: {
          back: 1
        }
      })
    },
    logout () {
      this.utils.GET(this.accountUrl + '/account/logout', res => {
        localStorage.setItem('isLogin', 0)
        localStorage.removeItem('userinfo')
        localStorage.removeItem('shop')
        localStorage.removeItem('planInfo')
        this.islogin = 0
        this.showMaskLogOut = false
        this.reload()
      })
    },
    getDetail (i) {
      let obj = {
        status: i,
        key: '',
        page: 1,
        rows: 999
      }
      this.utils.get(this.companyUrl + '/zxOrder/myMallOrderList', obj, res => {
        if (res.code === 0) {
          let dataArr = res.data.rows
          let conter = 0
          dataArr.forEach((item, index) => {
            if (item.order_state !== '失效') {
              conter += 1
            }
          })
          this.orderIconList[i].total = conter
        }
      })
    },
    hide () {
      this.showMask = false
      this.showMaskLogOut = false
    },
    callService () {
      this.YSF.init('1a5d46871ba2e8c628b5a7abe265ef26', {
        templateId: 123, // templateId表示自定义会话邀请的模板标识
        shuntId: 123, // shuntId表示访客选择多入口分流模版id
        sessionInvite: false, // sessionInvite表示是否开启会话邀请设置
        hidden: 1 // hidden表示是否隐藏访客端默认入口
      }).then(ysf => {
        ysf('open')
      }).catch(error => {
        console.log(error)
        console.log('sdk加载失败')
      })
      // if (this.enterType === 1) {
      //   if (this.utils.isIphone()) {
      //     window.webkit.messageHandlers.callService.postMessage('4001919119')
      //   } else {
      //     window.zxzx.callService('4001919119')
      //   }
      // } else {
      //   window.location.href = 'tel:4001919119'
      // }
    },
    getUserInfo () {
      var enterType = localStorage.getItem('enterType')
      console.log('enterType-----' + enterType)
      if (enterType === undefined || enterType === null) {
        this.enterType = 0
      } else {
        this.enterType = parseInt(enterType)
      }
      this.islogin = localStorage.getItem('isLogin')

      if (this.islogin === '1') {
        this.utils.get(this.companyUrl + '/ent/json', null, res => {
          localStorage.setItem('userinfo', JSON.stringify(res.data))
          this.user = res.data
        })
      }
    },
    getMsgData () { // 获取新消息数据
      if (localStorage.getItem('isLogin') === '1') {
        // 不需要loading
        let headers = {}
        headers['orgin'] = 'H5'
        var that = this
        Axios({
          method: 'get',
          url: this.companyUrl + '/message/count',
          headers: headers
        }).then(resultData => {
          let count = resultData.data.data
          if (count === undefined || count === null || count <= 0) {
            that.mHasNewMsgData = false
            console.log('暂无新消息')
          } else {
            console.log('有' + count + '条未读的消息')
            // Toast('有' + count + '条未读的消息')
            if (!that.mHasNewMsgData) {
              that.mHasNewMsgData = true
            }
          }
        })
      }
    },
    androidTabHeight (value) {
      // 设置android 模态导航条
      if (this.utils.isIphone() === true) {
        if (this.utils.isIphoneX() === true) {
          this.tabHeight = 20
        } else {
          this.tabHeight = 0
        }
      } else {
        this.tabHeight = parseInt(value)
      }
      console.log("androidTabHeight:",value)
    }

  },

  mounted () {
    this.getUserInfo()
    this.getMsgData()
    for (let i = 0; i < 4; i++) {
      this.getDetail(i)
    }
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 || parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      var _this = this
      window['androidTabHeight'] = (result) => {
        _this.androidTabHeight(result)
      }
      if (this.utils.isIphone() === true) {
        this.androidTabHeight('0')
      } else {
        this.androidTabHeight(window.zxzx.getNavigationBarHeight())
      }
    }
    var that = this
    this.mMsgTimer = setInterval(() => {
      that.getMsgData()
    }, 5000)
  },
  beforeDestroy () {
    clearInterval(this.mMsgTimer)
    console.log('定时器销毁')
  }
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  height: 100vh;
  background: #f2f2f2 url("../images/backgrd.png") no-repeat top center;
  background-size: 100% 217px;
  .username {
    position: absolute;
    top: 23.5px;
    left: 15px;
    font-size: 16px;
    color: #f8f8f8;
    line-height: 16px;
  }
  .msg-layout {
    position: absolute;
    top: 16px;
    right: 15px;
    width: 32px;
    height: 30px;
    img {
      width: 32px;
      height: 30px;
    }
    i {
      width: 5px;
      height: 5px;
      position: absolute;
      right: 0px;
      top: 0px;
      background-color: #ffffff;
      border-radius: 2.5px;
    }
  }
  .loginBtn {
    position: absolute;
    top: 35.5px;
    left: 15px;
    padding: 9px 18px 6px 10px;
    border-radius: 17.5px;
    background: #c41335;
    font-size: 12px;
    color: #f8f8f8;
    line-height: 15px;
    .icon {
      position: relative;
      display: inline-block;
      line-height: 15px;
      width: 20px;
      height: 19px;
      background: url("../images/unLogin.png") no-repeat center center;
      background-size: auto 100%;
      vertical-align: top;
      margin-right: 20px;
    }
  }
  .logined {
    padding: 5px 18px 3px 10px;
    top: 50px;
  }
  .nologin {
    .icon::after {
      position: absolute;
      content: "";
      width: 0.02rem;
      height: 17px;
      background: #eb1740;
      right: -8px;
    }
  }
  .orderPart {
    position: absolute;
    top: 94.5px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(100% - 30px);
    height: 123px;
    padding: 14px 15px 20px 14px;
    border-radius: 5px;
    background: #ffffff;
    .firstLine {
      font-size: 15px;
      color: #222222;
      line-height: 15px;
      font-weight: bold;
      margin-bottom: 24px;
      .checkmore {
        float: right;
        font-size: 12px;
        color: #91919c;
      }
    }
    .iconPart {
      width: 100%;
      height: 50px;
      display: flex;
      .item {
        position: relative;
        flex: 1;
        text-align: center;
        .itemIcon {
          width: 30px;
          margin: 0 auto;
        }
        .itemText {
          font-size: 12px;
          color: #7b7b84;
        }
        .total {
          position: absolute;
          padding: 1px 4px 2px 4px;
          border-radius: 8px;
          background: #dd2f21;
          font-size: 12px;
          color: #ffffff;
          line-height: 0.24rem;
          text-align: center;
          top: -4px;
          right: calc(50% - 24px);
          border: 0.01rem solid #ffffff;
        }
      }
    }
  }
  .buyCenter {
    position: absolute;
    top: 227px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(100% - 30px);
    height: 123px;
    padding: 14px 15px 20px 14px;
    border-radius: 5px;
    background: #ffffff;
    .firstLine {
      font-size: 15px;
      color: #222222;
      line-height: 15px;
      font-weight: bold;
      margin-bottom: 24px;
    }
    .iconPart {
      width: 100%;
      height: 50px;
      display: flex;
      .item {
        position: relative;
        flex: 1;
        text-align: center;
        .itemIcon {
          width: 30px;
          margin: 0 auto;
        }
        .itemText {
          font-size: 12px;
          color: #7b7b84;
        }
        .total {
          position: absolute;
          width: 21.5px;
          height: 13px;
          border-radius: 6px;
          background: #dd2f21;
          font-size: 12px;
          color: #ffffff;
          line-height: 0.24rem;
          text-align: center;
          top: 0;
          right: 14px;
        }
      }
    }
  }
  .tools {
    position: absolute;
    top: 360px; // 227px
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(100% - 30px);
    height: 123px;
    padding: 14px 15px 20px 14px;
    border-radius: 5px;
    background: #ffffff;
    .firstLine {
      font-size: 15px;
      color: #222222;
      line-height: 15px;
      font-weight: bold;
      margin-bottom: 24px;
    }
    .iconPart {
      width: 100%;
      height: 50px;
      display: flex;
      .item {
        position: relative;
        flex: 1;
        text-align: center;
        .itemIcon {
          width: 30px;
          margin: 0 auto;
        }
        .itemText {
          font-size: 12px;
          color: #7b7b84;
        }
        .total {
          position: absolute;
          width: 21.5px;
          height: 13px;
          border-radius: 6px;
          background: #dd2f21;
          font-size: 12px;
          color: #ffffff;
          line-height: 0.24rem;
          text-align: center;
          top: 0;
          right: 14px;
        }
      }
    }
  }
  .logOut {
    position: absolute;
    top: 493px; // 360px
    left: 0;
    right: 0;
    margin: 0 auto;
    width: calc(100% - 30px);
    border-radius: 5px;
    background: #ffffff;
    font-size: 14px;
    color: #7b7b84;
    text-align: center;
    line-height: 50px;
  }
}
.masker {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #000000;
  opacity: 0.3;
  z-index: 800;
}
.servicePhone {
  position: fixed;
  z-index: 1000;
  width: 100%;
  // height: 100px;
  background: #fff;
  bottom: 0;
  font-size: 0;
  .phoneNumber {
    background: #ffffff;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #000000;
    font-size: 14px;
    border-radius: 8px 8px 0 0;
    border-bottom: 0.01rem solid #eeeeee;
  }
  .cancle {
    background: #ffffff;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #c41335;
    font-size: 14px;
  }
}
// <div class="logOutPop" v-if="showMaskLogOut">
//   <p class="checkout">切换账户</p>
//   <p class="out">退出登录</p>
//   <p class="cancle" @click="hide()">取消</p>
// </div>
.logOutPop {
  background: #ffffff;
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 150px;
  bottom: 0;
  font-size: 0;
  .checkout,
  .out {
    background: #ffffff;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #000000;
    font-size: 14px;
    border-radius: 8px 8px 0 0;
    border-bottom: 0.01rem solid #eeeeee;
  }
  .cancle {
    background: #ffffff;
    height: 50px;
    text-align: center;
    line-height: 50px;
    color: #c41335;
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/shopping/personCenter/personHomePage.vue